var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDesigner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "auto",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.25H20V20H0V.361l12.5 12.5V1.25zM1.25 18.75h15.361L1.25 3.389V18.75zm15.889-1.25l1.25 1.25h.361V2.5h-5v1.25h2.5V5h-2.5v1.25h2.5V7.5h-2.5v1.25h3.75V10h-3.75v1.25h2.5v1.25h-2.5v1.25h2.5V15h-1.611l1.25 1.25H17.5v1.25h-.361zM3.75 10.361l5.889 5.889H3.75v-5.889zM5 13.39V15h1.611L5 13.389z",
    fill: "#323130"
  })));
}

export default SvgCustomDesigner;